import { useEffect, useState } from "react";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];
const STORAGE_KEY = "atlas_utm";

function readStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function captureFromUrl() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const captured = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) captured[key] = value.slice(0, 120);
  }
  return captured;
}

/**
 * Captures UTM parameters from the URL on first render and persists them
 * in sessionStorage so they can be attached to lead submissions.
 */
export function useUtmParams() {
  const [utm, setUtm] = useState(() => ({ ...readStored() }));

  useEffect(() => {
    const fresh = captureFromUrl();
    if (Object.keys(fresh).length > 0) {
      const merged = { ...readStored(), ...fresh };
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
      } catch {
        // ignore storage errors
      }
      setUtm(merged);
    }
  }, []);

  return utm;
}

export function getStoredUtmParams() {
  return readStored();
}
